import { useState } from "react";

import Img1 from "../assets/Gallery_Nexus/Img_1.jpeg";
import Img2 from "../assets/Gallery_Nexus/Img_2.jpeg";
import Img3 from "../assets/Gallery_Nexus/Img_4.jpeg";
import Img4 from "../assets/Gallery_Nexus/Img_8.jpeg";
import Img5 from "../assets/Gallery_Nexus/Img_18.jpeg";
import Img6 from "../assets/Gallery_Nexus/Img_11.jpeg";
import Img7 from "../assets/Gallery_Nexus/Img_12.jpeg";
import Img8 from "../assets/Gallery_Nexus/Img_13.jpeg";

function Gallery() {
  const galleryImages = [
    { id: 1, src: Img1, alt: "Therapy Session", title: "One-on-One Therapy" },
    { id: 2, src: Img2, alt: "Group Counseling", title: "Group Support Sessions" },
    { id: 3, src: Img3, alt: "Wellness Program", title: "Wellness & Fitness" },
    { id: 4, src: Img4, alt: "Mindfulness", title: "Mindfulness Classes" },
    { id: 5, src: Img5, alt: "Mental Health Awareness", title: "Mental Health Awareness" },
    { id: 6, src: Img6, alt: "Community Events", title: "Community Events" },
    { id: 7, src: Img7, alt: "Professional Consultation", title: "Expert Consultation" },
    { id: 8, src: Img8, alt: "Wellness Center", title: "Our Wellness Center" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section className="py-16 bg-gradient-to-b from-slate-800 to-slate-900 glossy-gallery">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Interactive Gallery
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            Hover over any tile to preview the image in the slider, or click to open the lightbox for a closer look.
          </p>
        </div>

        <div className="grid gap-8 xl:grid-cols-[1.5fr_1fr]">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl group bg-slate-900 glossy-card">
            <img
              src={galleryImages[currentIndex].src}
              alt={galleryImages[currentIndex].alt}
              className="w-full h-[420px] object-cover transition duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <p className="text-sm uppercase tracking-[0.3em] text-cyan-400 mb-2">
                Hover preview slider
              </p>
              <h3 className="text-4xl font-bold mb-3">{galleryImages[currentIndex].title}</h3>
              <p className="max-w-2xl text-sm text-slate-300">
                Explore the gallery by moving your mouse over the boxes or using the arrows below.
              </p>
            </div>

            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/20 p-3 text-white hover:bg-white/40 transition"
              aria-label="Previous slide"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/20 p-3 text-white hover:bg-white/40 transition"
              aria-label="Next slide"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
            {galleryImages.map((image, idx) => (
              <div
                key={image.id}
                onMouseEnter={() => goToSlide(idx)}
                onClick={() => setSelectedImage(image)}
              className={`relative overflow-hidden rounded-3xl cursor-pointer transition duration-300 ease-out shadow-lg border border-slate-700/50 hover:-translate-y-1 hover:shadow-2xl ${
                idx === currentIndex ? "ring-4 ring-cyan-400/70" : ""
                }`}
              >
                <img src={image.src} alt={image.alt} className="w-full h-40 object-cover transition duration-500" />
                <div className="absolute inset-0 bg-slate-950/0 hover:bg-slate-950/40 transition"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-slate-950/90 to-transparent">
                  <h4 className="text-sm font-semibold text-white">{image.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 flex justify-center gap-3">
          {galleryImages.map((_, idx) => (
            <button
              key={idx}
              onClick={() => goToSlide(idx)}
              className={`h-3 rounded-full transition ${
                idx === currentIndex
                  ? "w-10 bg-gradient-to-r from-cyan-400 to-orange-400"
                  : "w-3 bg-slate-600 hover:bg-slate-500"
              }`}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={() => setSelectedImage(null)}>
          <div className="relative w-full max-w-4xl rounded-3xl overflow-hidden bg-slate-900 shadow-2xl">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute right-4 top-4 z-10 rounded-full bg-slate-950/80 p-3 text-white hover:bg-slate-950"
              aria-label="Close lightbox"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img src={selectedImage.src} alt={selectedImage.alt} className="w-full max-h-[80vh] object-cover" />
            <div className="p-6 bg-slate-800">
              <h3 className="text-2xl font-bold text-white mb-2">{selectedImage.title}</h3>
              <p className="text-slate-400">{selectedImage.alt}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Gallery;
